/* eslint-disable no-console */
/* eslint-disable import/no-dynamic-require */
/* eslint-disable no-plusplus */
/* ============
 * Supplier Index
 * ============
 *
 * This page shows the list of Bills.
 */
import { mapGetters, mapMutations } from 'vuex';
import modulesService from './../../../../services/modules';
import SearchMixin from './../../../../mixins/search';
import moduleModal from './../../../../components/subscribeModal/subscribeModal.vue';
import customComponents from './../components';
import accountService from './../../../../services/account';
import wooCredentialsModal from './../../../../components/wooCredentialsModal/wooCredentialsModal.vue';
import wordpressCredentialsModal from './../../../../components/wordpressCredentialsModal/wordpressCredentialsModal.vue';
import unimicroCredentialsModal from './../../../../components/unimicroCredentialsModal/unimicroCredentialsModal.vue'; 
import powerofficeCredentialsModal from './../../../../components/powerofficeCredentialsModal/powerofficeCredentialsModal.vue'; 

export default {
  data() {
    return {
      loading: true,
      sortValue: '',
    };
  },

  computed: {
    ...mapGetters({
      modules: 'allModules',
    }),

    modulesList() {
      const listM = [];

      for (let i = 0; i < this.modules.length; i++) {
        let flag = false;
        let index = 0;
        for (let c = 0; c < listM.length; c++) {
          if (listM[c].group === this.modules[i].group) {
            flag = true;
            index = c;
          }
        }

        if (!flag) {
          listM.push({
            group: this.modules[i].group,
            modules: [this.modules[i]],
          });
        } else {
          listM[index].modules.push(this.modules[i]);
        }
      }

      return listM;
    },
  },

  mounted() {
    modulesService.items().then(() => {
      this.loading = false;
      if (this.$route.query.name) {
        for (const m of this.modulesList) {
          for (const mdl of m.modules) {
            if (mdl.name === this.$route.query.name) {
              this.subscribe(mdl);
              break;
            }
          }
        }
      }
    });
  },

  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      setModalContent: 'SET_MODAL_CONTENT',
      setModalProps: 'SET_MODAL_PROPS',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
      setModalSize: 'SET_MODAL_SIZE',
      setModalCloseOnClick: 'SET_MODAL_CLOSE_ON_CLICK',
      setModalCloseOnPressEscape: 'SET_MODAL_CLOSE_ON_PRESS_ESCAPE',
    }),

    updateFields(mod) {
      if (mod.name === 'WordPress') {
        this.wordpressCredentialsModal(mod);
      } else if (mod.name === 'WordPress WooCommerce') {
        this.woocommerceCredentialsModal(mod);
      } else if (mod.name === 'UniMicro') {
        this.unimicroCredentialsModal(mod);
      } else if (mod.name === 'PowerOffice') {
        this.powerofficeCredentialsModal(mod);
      } else if ((mod.fields !== null && mod.fields.length > 0) || mod.component) {
        this.showSubscribeModal(mod);
      }
    },

    subscribe(mod) {
      console.log(mod.name);
      if ((mod.fields !== null && mod.fields.length > 0) || mod.component) {
        this.showSubscribeModal(mod);
      } else if (mod.name === 'WordPress') {
        this.wordpressCredentialsModal(mod);
      } else if (mod.name === 'WordPress WooCommerce') {
        this.woocommerceCredentialsModal(mod);
      } else {
        this.$confirm(this.$t('static.module.warning.subscribe'), 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }).then(() => {
          modulesService.subscribe(mod.id, { module_id: mod.id }).then(() => {
            Promise.all([modulesService.items(), accountService.find()]);
          });
        }).catch(() => {});
      }
    },

    showSubscribeModal(module) {  
      // Set props
      this.setModalProps({ module });

      // Prevent background click and ESC close
      this.setModalCloseOnClick(false);
      this.setModalCloseOnPressEscape(false);

      // Choose modal component
      let component = moduleModal;
      if (module.component) {
        component = customComponents[module.component];
      }

      // Set modal content and show it
      this.setModalContent(() => component);
      this.toggleModal(true);
    },


    unsubscribe(id) {
      this.$confirm(this.$t('static.module.warning.unsubscribe'), 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(() => {
        modulesService.unsubscribe(id).then(() => {
          Promise.all([modulesService.items(), accountService.find()]);
        });
      }).catch(() => {});
    },

    /**
     * Open WooCommerce credentials modal
     */
    woocommerceCredentialsModal(value) {
      this.setModalContent(() => wooCredentialsModal);
      this.setModalProps({ mod: value });
      this.setModalCloseOnClick(false);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },

    /**
     * Open WordPress credentials modal
     */
    wordpressCredentialsModal(value) {
      this.setModalContent(() => wordpressCredentialsModal);
      this.setModalProps({ mod: value });
      this.setModalCloseOnClick(false);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },

    /**
     * Open UniMicro credentials modal ✅
     */
    unimicroCredentialsModal(value) {
      this.setModalContent(() => unimicroCredentialsModal);
      this.setModalProps({ mod: value });
      this.setModalCloseOnClick(false);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },

      /**
     * Open PowerOffice credentials modal ✅
     */
    powerofficeCredentialsModal(value) {
      this.setModalContent(() => powerofficeCredentialsModal);
      this.setModalProps({ mod: value });
      this.setModalCloseOnClick(false);
      this.setModalCloseOnPressEscape(false);
      this.toggleModal(true);
    },
  },

  mixins: [SearchMixin],

  components: {
    VCard: require('./../../../../components/card/card.vue'),
    VPagination: require('./../../../../components/paginationNew/paginationNew.vue'),
    VNoData: require('./../../../../components/noData/noData.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/modules/index/index.js